<template>
  <section
    ref="section9"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="9"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-x-hidden overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex w-full max-w-lg flex-col gap-8 lg:gap-11">
        <figure class="flex gap-3">
          <div><v-icon icon="stairs" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="text-heading-3-desktop">
              V katerem nadstropju je vaše stanovanje?
              <!-- V katerem nadstropju je vaša soba? -->
            </div>
          </div>
        </figure>
        <figure>
          <v-floor-selection
            ref="floorPicker"
            :default-floor="this.stepData.etage ?? 1"
            :routes="routes"
            :validation-errors="validationErrors"
          ></v-floor-selection>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm()"
        class="button button--md h-[48px] w-[240px] px-6"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';
import FloorSelection from '../FloorSelection.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
    "v-floor-selection": FloorSelection,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      floor: null,
    };
  },
  mounted() {
    //this.floor = this.stepData.etage
    this.floor = this.stepData.etage
  },
  methods: {
    submitForm() {
      this.$refs.floorPicker.submitForm('floor-selection-form');
    }
  },
};
</script>
